import { ExtAdapter } from "@hyext-inner/ext-web-comp";
import HyExtEndpointModule from "../HyExtEndpointModule";

export default class HyExtWebInnerEndpointModule extends HyExtEndpointModule {
  initEndpoint(adapter: ExtAdapter): Promise<void> {
    return Promise.resolve()
  }
  statusNotice(extTypeIconInfo: MidExtQuery.ExtTypeIconInfo, adapter: ExtAdapter): Promise<void> {
    return Promise.resolve()
  }
  textNotice(tips: string, adapter: ExtAdapter): Promise<void> {
    return Promise.resolve()
  }
  postInit(adapter: ExtAdapter): Promise<void> {
    return Promise.resolve()
  }
  showEndpointPanel(adapter: ExtAdapter): Promise<void> {
    throw new Error("Method not implemented.");
  }
  hideEndpointPanel(adapter: ExtAdapter): Promise<void> {
    throw new Error("Method not implemented.");
  }
  showEndpointEntrance(adapter: ExtAdapter): Promise<void> {
    throw new Error("Method not implemented.");
  }
  hideEndpointEntrance(adapter: ExtAdapter): Promise<void> {
    throw new Error("Method not implemented.");
  }
  ready(adapter: ExtAdapter): Promise<boolean> {
    return Promise.resolve(true)
  }
  showSupError(msg: string, adapter: ExtAdapter): Promise<void> {
    throw new Error("Method not implemented.");
  }
  getModalContainer(adapter: ExtAdapter): Promise<any> {
    return Promise.resolve($('body'))
  }
  close(content: string, adapter: ExtAdapter): Promise<void> {
    throw new Error("Method not implemented.");
  }
}